import { setGetWinnersLotteryAction } from '../action';
import { getWinnersLottery } from '../api/getWinnersLottery';

const setGetWinnersLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getWinnersLottery(params);

            if (data.status === 'success') {
                dispatch(setGetWinnersLotteryAction({
                    data: data.data,
                    page: data.count,
                }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetWinnersLottery
}